interface LikeResponse {
  data: {
    id: number
    likes: number
    hasLiked: boolean
  }
}

export function useLike(byteId: number) {
  const sdk = usePayloadSdk()
  const url = `${sdk.baseURL}/bytes/${byteId}/like`

  const toggle = async () => {
    await $fetch<LikeResponse>(url, {method: 'PUT'})
  }

  return {toggle}
}
